module.exports = new __parcel__URL__("component-preview.e6bd185f.svg").toString();